import type { ReactNode } from 'react';

/**
 * 外部リンクコンポーネント
 */
export const ExternalLink = ({
  href,
  className,
  onClick,
  openInNewTab,
  children,
}: {
  href: string;
  className: string;
  onClick?: () => void;
  openInNewTab?: boolean;
  children: ReactNode;
}) => {
  return (
    <a
      href={href}
      className={className}
      onClick={onClick}
      {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      {children}
    </a>
  );
};
